const AOS_CATEGORIES = {
    STATUS: {
        INCOMPLETE_PROFILE: "no bio/pic",
        DISCOGRAPHY_EMPTY: "No song",
        HYBRID_STATE: "Song/No Profile",
        NO_PRIMARY: "No Primary Lead",
        SONG_INDUCTION: "no description",
        PRESS_INDUCTION: "no press post",
        READY: "Ready"
    },
    TIERS: {
        NEWBIE: "Newbie (Never T50)",
        RETURNING: "Returning (T50 Peak)",
        VETERAN: "Veteran (T20 Peak)",
        PAID_VETERAN: "Paid Veteran (T20 Peak)",
        SCENE_LEADER: "Scene Leader (T10 Peak)",
        PAID_SCENE_LEADER: "Paid Scene Leader (T10 Peak)",
        NUCLEAR: "Nuclear (Global Priority)"
    },
    MOMENTUM: {
        PROMOTING: "Promoting (No Charting)",
        RISING_STAR: "Rising Star (Near T50)",
        CONTENDER_50: "Contender (T50)",
        CONTENDER_20: "Contender (T20)",
        TOP_CONTENDER: "Top Contender (Near T10)",
        ICON: "Icon (T10)",
        SUPERSTAR: "Superstar (In Top 5)",
        REIGNITE: "Reignite (Fell out of Top 50)",
        REEMERGENT: "Reemergent (Fell out of Top 20)",
        REVIVAL: "Revival (Fell out of Top 10)"
    }
};

module.exports = { AOS_CATEGORIES };